module.exports = __webpack_public_path__ + "website/img/core7_1.64c51168.png";